import { AppThunk } from "../../store";
import { setGlobalLoading } from "../../reducers/common/globalLoading";

export const setGlobalLoadingAction =
    (loading: boolean): AppThunk =>
    (dispatch) => {
        dispatch(setGlobalLoading(loading));
    };
